"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const storage_1 = require("../lib/storage");
const storeEvent_1 = require("../lib/storeEvent");
const wa_1 = require("../lib/wa");
const TREASURE_BOX_KEY = 'TreasureBox';
class TreasureBoxStore {
    constructor(config) {
        this.config = config;
        this.localStore = new storage_1.LocalStorage(TREASURE_BOX_KEY);
        this.name = this.config.custom.name;
        this.isShow = false;
        this.initShowScene();
        mobx_1.reaction(() => this.isShow, (isShow) => {
            if (isShow) {
                this.currentLimitState.show++;
                this.currentLimitState.showAt = Date.now();
                this.currentLimitState.todayShow++;
                this.updateLimitState();
            }
        });
    }
    openUrl() {
        this.currentLimitState.entry++;
        this.updateLimitState();
        window.location.href = this.config.custom.entry;
        wa_1.WaAction.log({
            ac_name: 'entry',
            ac_type: 'customEntry', name: this.name,
        });
    }
    close() {
        this.isShow = false;
        this.currentLimitState.cancal++;
        this.updateLimitState();
        wa_1.WaAction.log({
            ac_name: 'cancel', ac_type: 'customEntry', name: this.name,
        });
    }
    show() {
        wa_1.WaAction.log({
            ac_name: 'show', ac_type: 'customEntry', name: this.name,
        });
    }
    checkShowLimit() {
        const { limit } = this.config.use;
        if (limit.show <= this.currentLimitState.show
            || limit.cancal <= this.currentLimitState.cancal
            || limit.entry <= this.currentLimitState.entry) {
            return false;
        }
        // 用户主动关闭后，N天后不能展示
        if (this.currentLimitState.cancal > 0 && (Date.now() - this.currentLimitState.showAt) / (3600 * 1000 * 24) < limit.cancelDays) {
            return false;
        }
        return true;
    }
    initLimitState(type) {
        this.currentShowType = type;
        const storageKey = `limitState/${this.currentShowType}`;
        const limitState = this.localStore.getItem(storageKey) || {};
        if (limitState[this.name]) {
            this.currentLimitState = limitState[this.name];
        }
        if (!this.currentLimitState) {
            this.currentLimitState = {
                createAt: Date.now(),
                updateAt: Date.now(),
                showAt: Date.now(),
                todayShow: 0,
                show: 0,
                cancal: 0,
                entry: 0,
            };
        }
        if (!this.isToday(this.currentLimitState.showAt)) {
            this.currentLimitState.todayShow = 0;
        }
        return this.currentLimitState;
    }
    updateLimitState() {
        const storageKey = `limitState/${this.currentShowType}`;
        const limitState = this.localStore.getItem(storageKey) || {};
        this.currentLimitState.updateAt = Date.now();
        limitState[this.name] = this.currentLimitState;
        this.localStore.setItem(storageKey, limitState);
    }
    initShowScene() {
        if (this.config.expiredTime < Date.now()) {
            this.isShow = false;
            return;
        }
        // 根据场景判断出现
        const { showScene } = this.config.use;
        if (showScene.afterLoaded) {
            this.initShowType(showScene.afterLoaded);
        }
        if (showScene.afterLike) {
            storeEvent_1.default.addEventHandler('article:like:click', () => {
                this.initShowType(showScene.afterLike);
            });
        }
        if (showScene.afterRead) {
            storeEvent_1.default.addEventHandler('read:finish', () => {
                this.initShowType(showScene.afterRead);
            });
        }
        if (showScene.afterComment) {
            storeEvent_1.default.addEventHandler('comment:add', () => {
                this.initShowType(showScene.afterComment);
            });
        }
    }
    initShowType(type) {
        const { showType } = this.config.use;
        switch (type) {
            case 'randomShow': {
                // 在一定随机秒数后出现
                this.initLimitState(type);
                const min = showType.randomShow.min;
                const max = showType.randomShow.max;
                const delay = (Math.random() * (max - min) + min) * 1000;
                setTimeout(() => {
                    this.isShow = this.checkShowLimit();
                }, delay);
                return;
            }
            case 'todayRandomShow': {
                // 在一天内随机概率出现
                this.initLimitState(type);
                const min = showType.todayRandomShow.min;
                const max = showType.todayRandomShow.max;
                const maxShow = Math.round(Math.random() * (max - min)) + min;
                // 当天首次展示概率
                if (this.currentLimitState.todayShow === 0 && Math.random() * 100 <= showType.todayRandomShow.firstOpenProbability) {
                    this.isShow = this.checkShowLimit();
                }
                // 当天再次展示概率
                if (this.currentLimitState.todayShow < maxShow && Math.random() * 100 <= showType.todayRandomShow.showProbability) {
                    this.isShow = this.checkShowLimit();
                }
            }
        }
    }
    isToday(time) {
        return new Date(time).toString().substr(0, 16) === new Date().toString().substr(0, 16);
    }
}
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Boolean)
], TreasureBoxStore.prototype, "isShow", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Boolean)
], TreasureBoxStore.prototype, "isStartToLoad", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Object)
], TreasureBoxStore.prototype, "config", void 0);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], TreasureBoxStore.prototype, "openUrl", null);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], TreasureBoxStore.prototype, "close", null);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], TreasureBoxStore.prototype, "show", null);
exports.default = TreasureBoxStore;
//# sourceMappingURL=data:application/json;base64,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